import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';

class SecondaryButton extends Component {

    render() {
        return (
            <input className="btn btn-secondary"
                   type="button"
                   value={this.props.valueKey === undefined ? this.props.value : i18next.t(this.props.valueKey)}
                   onClick={this.props.onClick}/>
        );
    }
}

SecondaryButton.propTypes = {
    value: PropTypes.string,
    valueKey: PropTypes.string,
    onClick: PropTypes.func
};

export default SecondaryButton;